import React from "react";
import { Quote, User } from "lucide-react"; // Keep Quote & User from lucide
import { AiFillStar } from "react-icons/ai"; // React-icons star
import HomeServices from "./HomeServices";
import HomeAboutUs from "./HomeAboutUs";
import CTA from "../Cta";
import Marque from "../Marque";
import BestServices from "./BestService";
import CountUpCards from "../CountUpCards";
import Approach from "./Approach";
import BookSessionForm from "../BookSessionForm";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  return (
    <>
      <main className="hob-main-home-section">
        <section className="hob-main-home-hero">
          <div className="hob-main-home-left">
            <h2 className="hob-main-home-heading">
              Guiding You Toward Mental Clarity and Balance
            </h2>
            <p className="hob-main-home-paragraph">
              Personalized therapy sessions to support your emotional well-being,
              resilience, and personal growth.
            </p>
            <div className="hob-main-home-cta">
              <button
                onClick={() => navigate("/book-session")}
                className="hob-main-home-cta-primary"
                style={{ cursor: "pointer" }}
              >
                Book Your Session Today
              </button>
            </div>
          </div>

          <div className="hob-main-home-right">
            {/* Testimonial */}
            <div className="hob-main-right-testimonial">
              <span className="hob-testimonial-icon">
                <Quote size={20} />
              </span>
              <p className="hob-testimonial-text">
                “Guidance has helped me manage stress and improve my
                emotional balance. Truly life-changing!”
              </p>
            </div>

            <img
              src="https://i.pinimg.com/736x/2c/8c/3f/2c8c3fee236dc10606c323bca207f16f.jpg"
              alt="Therapy Session"
              className="hob-main-home-image"
            />

            <div className="hob-main-right1-testimonial">
              <span className="hob-testimonial-icon">
                <User size={20} />
              </span>
              <p className="hob-testimonial-text">Ritika Rajat</p>
              <div className="hob-testimonial-stars" style={{ display: "flex", gap: "4px" }}>
                {[...Array(5)].map((_, i) => (
                  <AiFillStar key={i} color="#22C55E" size={16} />
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Marque />
      <HomeAboutUs />
      <CountUpCards />
      <Approach />
      <div id="services-section-hob">
        <HomeServices />
      </div>
      <BestServices />
      <CTA />
      <BookSessionForm />
    </>
  );
};

export default Home;
